
(function() {
    'use strict';
    
    /**
     * Mark all existing accordion elements as initialized
     */
    function markExistingAccordions() {
        // Mark regular accordion buttons
        var accordionButtons = document.querySelectorAll('.qld__accordion__title');
        accordionButtons.forEach(function(button) {
            button.setAttribute('data-accordion-initialized', 'true');
        });
        
        // Mark toggle-all buttons
        var toggleAllButtons = document.querySelectorAll('.qld__accordion__toggle-btn');
        toggleAllButtons.forEach(function(button) {
            button.setAttribute('data-accordion-initialized', 'true');
        });
    }
    
    /**
     * Initialize new accordion elements using the existing QLD.accordion methods
     * @param {HTMLElement} element - The element to check and initialize
     */
    function initializeNewAccordion(element) {
        if (!element || element.nodeType !== 1) return; // Only process element nodes
        
        // Check if this element itself is an accordion button
        var buttonsToInit = [];
        var toggleAllToInit = [];
        
        if (element.classList) {
            if (element.classList.contains('qld__accordion__title') && 
                !element.hasAttribute('data-accordion-initialized')) {
                buttonsToInit.push(element);
            }
            
            if (element.classList.contains('qld__accordion__toggle-btn') && 
                !element.hasAttribute('data-accordion-initialized')) {
                toggleAllToInit.push(element);
            }
        }
        
        // Find accordion buttons within the element
        if (element.querySelectorAll) {
            var childButtons = element.querySelectorAll('.qld__accordion__title:not([data-accordion-initialized])');
            var childToggleAll = element.querySelectorAll('.qld__accordion__toggle-btn:not([data-accordion-initialized])');
            
            childButtons.forEach(function(btn) { buttonsToInit.push(btn); });
            childToggleAll.forEach(function(btn) { toggleAllToInit.push(btn); });
        }
        
        // Initialize accordion buttons using existing accordion.Toggle
        buttonsToInit.forEach(function(button) {
            button.setAttribute('data-accordion-initialized', 'true');
            button.addEventListener('click', function() {
                QLD.accordion.Toggle(button);
            });
        });
        
        // Initialize toggle-all buttons using existing accordion.ToggleAll
        toggleAllToInit.forEach(function(button) {
            button.setAttribute('data-accordion-initialized', 'true');
            button.addEventListener('click', function() {
                QLD.accordion.ToggleAll(button);
            });
        });
    }
    
    /**
     * Set up MutationObserver to watch for dynamically added accordions
     */
    function setupMutationObserver() {
        if (typeof MutationObserver === 'undefined') {
            return;
        }
        
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    initializeNewAccordion(node);
                });
            });
        });
        
        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    /**
     * Main initialization function
     */
    function init() {
        markExistingAccordions();
        setupMutationObserver();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // Expose a manual initialization function for edge cases
    window.QLD = window.QLD || {};
    window.QLD.accordion = window.QLD.accordion || {};
    window.QLD.accordion.initDynamic = function(container) {
        if (container) {
            initializeNewAccordion(container);
        } else {
            console.warn('QLD.accordion.initDynamic requires a container element');
        }
    };
    
})();